import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { UnauthorizedLayout } from 'APP/components/UnauthorizedLayout/UnauthorizedLayout';

import { DeepLinkError } from '../DeepLinkError/DeepLinkError';
import { DeepLinkViewAction } from '../DeepLinkViewAction/DeepLinkViewAction';
import { MobileAppsBlock } from '../MobileAppsBlock/MobileAppsBlock';
import { useDeepLinkViewPresenter } from './DeepLinkView.presenter';
import styles from './DeepLinkView.styles.m.css';

interface IDeepLinkViewProps {}

export const DeepLinkView: FC<IDeepLinkViewProps> = observer(() => {
  const presenter = useDeepLinkViewPresenter();

  return (
    <UnauthorizedLayout footer={<MobileAppsBlock className={styles.footer} />}>
      {presenter.isError ? (
        <DeepLinkError isExpired={presenter.isExpired} />
      ) : (
        <DeepLinkViewAction
          appLink={presenter.appLink}
          isDisabled={presenter.isTryToRedirect}
          deepLinkType={presenter.deepLinkType}
        />
      )}
    </UnauthorizedLayout>
  );
});
